import styled from 'styled-components';

export const DialogHeadingContainer = styled.div`
  display: flex;
  padding-top: 8px;
  gap: 8px;
`;

export const DialogHeadingStyle = styled.div`
  line-height: 40px;
  flex: 1;
`;
